<template>
  <a-layout style="padding-top: 65px;">
    
    <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
      <!-- 选择框 -->
      <div style="margin-left: 10px;margin-bottom: 10px;">
        <a-radio-group v-model:value="currentKey">
          <a-radio-button value="ebook">电子书</a-radio-button>
          <a-radio-button value="track">学习路径</a-radio-button>
        </a-radio-group>
      </div>
      <!-- 电子书统计 -->
      <div v-if="currentKey == 'ebook'">
        <the-statistic-ebook></the-statistic-ebook>
      </div>
      <!-- 学习路径统计 -->
      <div v-else-if="currentKey == 'track'">
        <the-statistic-track></the-statistic-track>
      </div>
    </a-layout-content>

    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>


</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import TheStatisticEbook from '@/components/the-statistic-ebook.vue';
import TheStatisticTrack from '@/components/the-statistic-track.vue';
import TheFooter from "@/components/the-footer.vue";

declare let hexMd5: any;
declare let KEY: any;

export default defineComponent({
  name: 'AdminStatistic',
  components: {
    TheStatisticEbook,
    TheStatisticTrack,
    TheFooter
  },
  setup() {

    // 电子书：ebook, 学习路径: track
    let currentKey = ref<string>('ebook');

    onMounted(() => {

    });

    return {
      currentKey,
    }
  }
});
</script>

<style scoped>
/* img {
  width: 50px;
  height: 50px;
} */
</style>
